import PropTypes from "prop-types";
import './DishCreatorHeader.scss';

const DishCreatorHeader = ({id, name, index, expanded, onRemoveClick}) => {
    const handleRemoveClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        onRemoveClick(id);
    }
    const label = name
        ? (<p>Dish: {name}</p>)
        : (<p>Dish {index + 1}</p>)

    return (
        <div className={`dish-creator-header ${!expanded ? 'dish-creator-header--collapsed' : ''}`}>
            {label}
            <div
                className="dish-creator-header__remove-btn"
                onClick={handleRemoveClick}
                role="button"
                tabIndex={0}
            />
        </div>
    );
}

DishCreatorHeader.propTypes = {
    name: PropTypes.string,
    index: PropTypes.number.isRequired,
    id: PropTypes.string,
    expanded: PropTypes.bool,
    onRemoveClick: PropTypes.func
};

export default DishCreatorHeader;